import * as React from "react";
import { ViajeCobranzaForm } from "./form";
import { match } from "react-router";
import { createSelector } from "keautils";
import { resources } from "app/main/std";
import { observeResource } from "kea-resource";
interface Props {
    match: match<{ id: string }>
}

/**Ventana para ver el detalle de un viaje de cobranza */
export class ViajeCobranzaDetalle extends React.PureComponent<Props> {
    id = (x: Props) => Number.parseInt(x.match.params.id);
    value = createSelector(this.id, id => observeResource(resources.Cobranza2.GetViaje, id));

    render() {
        return <ViajeCobranzaForm value={this.value(this.props)} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/edit/index.tsx